module.exports = __webpack_public_path__ + "img/app9.bbcd0783.jpg";